import { z } from 'zod';
import { PartnerMaterialAdminSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * List Partner Materials (superadmin)
 * GET /api/v2/admin/partner-materials
 */ export const ListPartnerMaterialsAdminResponseSchema = z.object({
    data: z.array(PartnerMaterialAdminSchema)
});

//# sourceMappingURL=list-partner-materials-admin.schema.js.map